module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel03_1280_1280_vi-e0e92f76693af34997668c90568037c4.jpg";